import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import CudelLogo from '../../assets/images/cudel_logo.png'
import ImageAsBase64 from '../../utils/imageToBase64';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 10,
    fontFamily: 'Roboto'
  },
  header: {
    flexDirection: 'row',
    // marginBottom: 20,
    // borderBottomWidth: 1,
    // borderBottomColor: '#112131',
    // borderBottomStyle: 'solid',
    // paddingBottom: 10
  },
  logo: {
    width: 80,
    height: 30,
    marginRight: 20,
    objectFit: 'contain'
  },
  companyInfo: {
    flex: 1
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10
  },
  subtitle: {
    fontSize: 10,
    marginBottom: 5
  },
  contactDetails:{
    height:'100%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-end',
    // alignItems:'flex-end'
  },
  contactInfo: {
    fontSize: 10,
    marginBottom: 3
  },
  section: {
    margin: 10,
    padding: 10
  },
  grid: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#112131',
    borderBottomStyle: 'solid',
    alignItems: 'center',
    height: 24,
    textAlign: 'center',
    fontSize: 10
  },
  tableHeader: {
    backgroundColor: '#f0f0f0'
  },
  description: {
    width: '30%'
  },
  hsn: {
    width: '10%'
  },
  qty: {
    width: '10%'
  },
  rate: {
    width: '10%'
  },
  taxable: {
    width: '15%'
  },
  igst: {
    width: '10%'
  },
  igstAmt: {
    width: '10%'
  },
  total: {
    width: '15%'
  },
  rightAlign: {
    textAlign: 'right'
  },
  totalSection: {
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#112131',
    borderTopStyle: 'solid',
    paddingTop: 10
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 5
  },
  totalLabel: {
    width: 150,
    textAlign: 'right',
    paddingRight: 10,
    fontSize: 10
  },
  totalValue: {
    width: 100,
    textAlign: 'right',
    fontSize: 10
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    fontSize: 8
  },
  companyTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  companyDetail: {
    fontSize: 8,
    marginBottom: 2,
  },
  buyerInfo: {
    // borderTop:"1px solid black",
    padding:2
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
  }
});
const Header = ({buyer,logoData,invoice}) => {
  // const invoiceData = {
  //   companyName: "GUJARAT FREIGHT TOOLS",
  //   companyDetails: {
  //     address: "B 154, B Block",
  //     location: "Sector 63, Noida",
  //     city: "Uttar Pradesh 201301",
  //     contact: {
  //       // tel: "079-25820309",
  //       web: "www.cudel.in",
  //       email: "hello@cudel.in"
  //     }
  //   },
  //   gstin: "24HDE7487RE5RT4",
  //   customer: {
  //     name: "Kevin Motors",
  //     address: "Chandani Chok, New Delhi, Opposite Statue, New Delhi, Delhi - 110014",
  //     phone: "9372346666",
  //     gstin: "07AOLCC1206D1ZG"
  //   },
  //   invoice: {
  //     number: "GST112020",
  //     date: "04-Mar-2020",
  //     challanNo: "865",
  //     challanDate: "03-Mar-2020",
  //     poNo: "66",
  //     deliveryDate: "04-Mar-2020",
  //     lrNo: "958",
  //     eWayNo: "EWB54864584"
  //   },
  //   items: [
  //     {
  //       name: "Automatic Saw",
  //       hsn: "8202",
  //       qty: "1.00 PCS",
  //       rate: 586.00,
  //       taxableValue: 586.00,
  //       igst: 9.00,
  //       igstAmount: 52.74,
  //       total: 638.74
  //     },
  //     {
  //       name: "Stanley Hammer",
  //       hsn: "8205",
  //       qty: "1.00 PCS",
  //       rate: 568.00,
  //       taxableValue: 568.00,
  //       igst: 9.00,
  //       igstAmount: 51.12,
  //       total: 619.12
  //     }
  //   ]
  // };
  const company = {
    name: "Cudel Delight Solutions Pvt. Ltd.",
    address: "B-154, Sector-63, Noida, Gautambuddha Nagar,",
    state: "Uttar Pradesh",
    pincode: "201301",
    gstin: "09AAHCC0707E1ZP",
    stateCode: "09"
  };
  const [loading, setLoading] = useState(false);
  // const [logoData, setLogoData] = useState(null);


  // // Load logo on component mount
  // useEffect(() => {
  //   const loadLogo = async () => {
  //     try {
  //       // Replace with your actual logo path
  //       const base64Logo = await ImageAsBase64(CudelLogo);
  //       setLogoData(base64Logo);
  //     } catch (error) {
  //       console.error('Error loading logo:', error);
  //     }
  //   };

  //   loadLogo();
  // }, []);
  return (
    <View style={{}}>
      <View style={{textAlign: 'center', width:'100%'}}>
        <Text style={{fontSize:'8px'}}>Tax Invoice</Text>
      </View>
      <View style={{display:'flex',flexDirection:'column',border:'1px solid black',marginBottom:0}} fixed>
        {/* Header top */}
        <View style={{display:'flex',flexDirection:'row',borderBottom:'1px solid black'}}>
          {/* Header Top Left */}
          <View style={{width:'50%',borderRight:'1px solid black'}}>
            <View style={{display:'flex',flexDirection:'row'}}>
              <View style={{padding:2}}>
                {logoData && (
                  <Image
                    style={styles.logo}
                    src={logoData}
                  />
                )}
              </View>
              <View>
                <Text style={styles.companyTitle}>{company.name}</Text>
                <Text style={styles.companyDetail}>B-154, Sector-63, Noida, Gautambuddha Nagar,</Text>
                <Text style={styles.companyDetail}>Uttar Pradesh, 201301</Text>
                <Text style={styles.companyDetail}>GSTIN/UIN: 09AAHCC0707E1ZP</Text>
                <Text style={styles.companyDetail}>State Name : Uttar Pradesh, Code : 09</Text>
              </View>
            </View>
          </View>
          {/* Header Top right */}
          <View style={{width:'50%'}}>
            <View style={{display:'flex',flexDirection:'row',borderBottom:'1px solid black'}}>
              <View style={{padding:'1%',display:'flex',flexDirection:'row',gap:2}}>
                <Text style={{fontSize:'8px',fontWeight:'bold'}}>Invoice No :</Text>
                {/* <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text> */}
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}>{invoice?.number}</Text>
              </View>
              {/* <View style={{width:'50%',padding:'1%',display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'25%'}}>Dated</Text>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text>
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}>{invoice?.date}</Text>
              </View> */}
            </View>
            <View style={{display:'flex',flexDirection:'row',borderBottom:'1px solid black',gap:2}}>
              
              <View style={{borderRight:'1px solid black',width:'50%',padding:'0.9%',display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'25%'}}>Dated</Text>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text>
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}>{invoice?.date}</Text>
              </View>
              <View style={{width:'50%',padding:'0.9%',display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'65%'}}>Mode/Terms of Payment</Text>
                <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text>
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}>{invoice.mode}</Text>
              </View>
            </View>
            <View style={{display:'flex',flexDirection:'row',borderBottom:'1px solid black',gap:2}}>
              <View style={{borderRight:'1px solid black',width:'50%',padding:2,display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold'}}>Reference No. & Date :</Text>
                {/* <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text> */}
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}></Text>
              </View>
              <View style={{width:'50%',padding:2,display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold'}}>Reference :</Text>
                {/* <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text> */}
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}></Text>
              </View>
            </View>
            <View style={{display:'flex',flexDirection:'row',gap:2}}>
              <View style={{borderRight:'1px solid black',width:'50%',padding:4,display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold'}}>Buyer's Order No :</Text>
                {/* <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text> */}
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}></Text>
              </View>
              <View style={{width:'50%',padding:4,display:'flex',flexDirection:'row'}}>
                <Text style={{fontSize:'8px',fontWeight:'bold'}}>Dated :</Text>
                {/* <Text style={{fontSize:'8px',fontWeight:'bold',width:'5%'}}>: </Text> */}
                <Text style={{fontSize:'8px',textTransform:'uppercase'}}></Text>
              </View>
            </View>

          </View>
        </View>
        
        {/* Header Bottom */}
        <View style={{display:'flex',flexDirection:'row'}}>

          {/* Header Bottom Left */}
          <View style={{borderRight:'1px solid black',width:'50%'}}>            
            <View style={styles.buyerInfo}>
              <Text style={styles.sectionTitle}>Buyer (Bill to)</Text>
              <Text style={[styles.companyDetail,{fontWeight:'bold'}]}>{buyer?.name}</Text>
              <Text style={styles.companyDetail}>{buyer?.address}</Text>
              <Text style={styles.companyDetail}>{buyer?.state}, PIN CODE-{buyer.pincode}</Text>
              <Text style={styles.companyDetail}>PAN/IT No: {buyer.panIt}</Text>
              <Text style={styles.companyDetail}>GSTIN/UIN: {buyer.gstin}</Text>
              <Text style={styles.companyDetail}>PLACE OF SUPPLY SERVICE STATE : {buyer.placeOfSupply}, Code : {buyer?.stateCode}</Text>
            </View>
          </View>
          {/* Header Bottom Right */}
          <View style={{display:'flex',flexDirection:'row',padding:2}}>
            <Text style={{fontSize:'8px',fontWeight:'bold',width:'40%'}}>Terms of Delivery :</Text>
            <Text style={{fontSize:'8px',fontWeight:'bold'}}> </Text>
          </View>
        </View>
      </View>
      
    </View>
    
  )
}

export default Header
